import React from "react";
import { FormattedMessage } from "react-intl";

import { Button } from "../../../../components/button/Button";
import { Icon } from "../../../../components/icon/Icon";
import { useIntlTranslate } from "../../../../hooks";

import "./ImageUploadControls.scss";

export const ImageUploadControls = ({
  onRemoveFile,
  openUpload,
}: {
  onRemoveFile: () => void;
  openUpload: () => void;
}) => {
  const translate = useIntlTranslate();
  const ariaLabel = translate("aria_remove_image");

  return (
    <div className="image-upload-controls" data-testid="image-upload-controls">
      <Button
        color="secondary"
        onClick={openUpload}
        aria-describedby="image-upload-legend"
      >
        <Icon icon="fa-regular fa-upload color-secondary" />
        <span>
          <FormattedMessage id="upload_image" />
        </span>
      </Button>
      <Button
        color={"destructive"}
        isOutline={true}
        onClick={onRemoveFile}
        data-testid="remove-uploaded-image-button"
        aria-label={ariaLabel}
      >
        <Icon icon="fa-regular fa-trash color-danger" />
        <span>
          <FormattedMessage id="remove" />
        </span>
      </Button>
    </div>
  );
};
